import { combineReducers } from 'redux';
import trackingPage from './trackingPage';
import ui from './ui';

const appReducer = combineReducers({
  trackingPage,
  ui,
});

const rootReducer = (state, action) => {
  if (action.type === 'RESET_STORE') {
    // eslint-disable-next-line no-param-reassign
    state = null;
  }
  return appReducer(state, action);
};

export default rootReducer;
